import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import RenderCategoryDetails from '../../_common/renderCategoryDetails.mdx';
import AchPaymentPayload from '../../_common/klarnaPaymentPayload.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`A promise that resolves to an instance of `}<inlineCode parentName="p">{`IAchPaymentMethodManager`}</inlineCode>{` or `}<inlineCode parentName="p">{`null`}</inlineCode>{`.`}</p>
    <Group summary='IAchPaymentMethodManager' mdxType="Group">
      <Item title='start' subtitle='(data: T) => Promise<Validation | undefined>' mdxType="Item">
        <p>{`Submits and validates the customer data starting the ACH payment method flow. `}</p>
        <p>{`When the payment method is `}<inlineCode parentName="p">{`STRIPE_ACH`}</inlineCode>{`, the required data `}<inlineCode parentName="p">{`T`}</inlineCode>{` is:`}</p>
        <pre><code parentName="pre" {...{
            "className": "language-typescript"
          }}>{`interface StripeAchFormData {
    firstName: stringl;
    lastName: string;
    emailAddress: string
}
`}</code></pre>
      </Item>
      <Item title='collectBankAccountDetails' subtitle='() => Promise<void>' mdxType="Item">
        <p>{`When the payment method is `}<inlineCode parentName="p">{`STRIPE_ACH`}</inlineCode>{`, displays the Stripe UI to collect the bank account details.`}</p>
        <p>{`Throws an error if the `}<inlineCode parentName="p">{`start`}</inlineCode>{` method didn't run successfully or wasn't called before.`}</p>
      </Item>
      <Item title='confirmMandate' subtitle='() => Promise<void>' mdxType="Item">
        <p>{`Submits the mandate confirmation. Should be triggered by a "Confirm" button next to the mandate text.`}</p>
        <p>{`Throws an error if the methods `}<inlineCode parentName="p">{`start`}</inlineCode>{` and `}<inlineCode parentName="p">{`collectBankAccountDetails`}</inlineCode>{` weren't successfully called before.`}</p>
      </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      